import tw from 'twin.macro';

export const CardWrapper = tw.div`w-full h-[8.375rem] rounded-sm bg-softYellow 
    flex flex-col justify-center items-center gap-1 py-3 relative`;

// circles
export const Circle1 = tw.div`w-8 h-8 absolute -top-3 -left-3 rounded-[90% / 80% 0] bg-white`;
export const Circle2 = tw.div`w-8 h-8 absolute -top-3 -right-3  rounded-[0 80% / 90%] bg-white`;
export const Circle3 = tw.div`w-8 h-8 absolute -bottom-3 -left-3 rounded-[0 80% / 90%] bg-white`;
export const Circle4 = tw.div`w-8 h-8 absolute -bottom-3 -right-3 rounded-[90% / 80% 0] bg-white`;

export const CardTitle = tw.span`text-[16px] font-bold capitalize text-[#161F21] text-opacity-50`;

export const CardCoupon = tw.h1`text-[48px] font-bold uppercase`;
